import React, { memo } from 'react'

import Image from 'next/image'

const RenderImage = ({ image, onRemove, readOnly }: { image: string; onRemove?: () => void; readOnly: boolean }) => {
  return (
    <>
      {!readOnly && (
        <button
          className="absolute right-2 top-2 z-[1] flex h-[24px] w-[24px] items-center justify-center rounded-full bg-white"
          onClick={onRemove}
        >
          <svg width="12" height="12" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 1L1 5" stroke="#11142D" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5 5L1 1" stroke="#11142D" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      )}
      <Image
        className="z-0 object-center"
        width={518}
        height={280}
        style={{ width: '100%' }}
        sizes="100vw"
        src={image}
        alt={``}
      />
    </>
  )
}
export const RenderImagesPost = memo(
  ({ images, readOnly = true, onRemove }: { images: any[]; readOnly?: boolean; onRemove?: (v: number) => void }) => {
    if (!images || images.length === 0) {
      return null
    }
    if (images.length === 1) {
      return (
        <div className="relative z-0 w-full overflow-hidden rounded-[12px] ">
          <RenderImage
            readOnly={readOnly}
            onRemove={() => onRemove?.(0)}
            image={images[0] && images[0] instanceof File ? URL.createObjectURL(images[0]) : images[0]}
          />
        </div>
      )
    }
    if (images.length === 2) {
      return (
        <div className="flex gap-1 overflow-hidden rounded-[12px]">
          <div className="relative z-0 aspect-[139/142] w-full">
            <RenderImage
              onRemove={() => onRemove?.(0)}
              readOnly={readOnly}
              image={images[0] && images[0] instanceof File ? URL.createObjectURL(images[0]) : images[0]}
            />
          </div>
          <div className="relative z-0 aspect-[139/142] w-full">
            <RenderImage
              readOnly={readOnly}
              onRemove={() => onRemove?.(1)}
              image={images[1] && images[1] instanceof File ? URL.createObjectURL(images[1]) : images[1]}
            />
          </div>
        </div>
      )
    }
    if (images.length === 3) {
      return (
        <div className="flex flex-wrap gap-1 overflow-hidden rounded-[12px]">
          <div className="relative aspect-[16/7] w-full basis-[2/2]">
            <RenderImage
              onRemove={() => onRemove?.(0)}
              readOnly={readOnly}
              image={images[0] && images[0] instanceof File ? URL.createObjectURL(images[0]) : images[0]}
            />
          </div>
          <div className="relative aspect-[16/9] flex-1">
            <RenderImage
              onRemove={() => onRemove?.(1)}
              readOnly={readOnly}
              image={images[1] && images[1] instanceof File ? URL.createObjectURL(images[1]) : images[1]}
            />
          </div>
          <div className="relative aspect-[16/9] flex-1">
            <RenderImage
              onRemove={() => onRemove?.(2)}
              readOnly={readOnly}
              image={images[2] && images[2] instanceof File ? URL.createObjectURL(images[2]) : images[2]}
            />
          </div>
        </div>
      )
    }
    if (images.length === 4) {
      return (
        <div className="grid grid-cols-2 gap-1 overflow-hidden rounded-[12px]">
          {images.map((image, i) => (
            <div key={i} className="relative aspect-[257/138]">
              <RenderImage
                onRemove={() => onRemove?.(i)}
                readOnly={readOnly}
                image={image instanceof File ? URL.createObjectURL(image) : image}
              />
            </div>
          ))}
        </div>
      )
    }

    return (
      <div className="grid grid-cols-2 gap-1 overflow-hidden rounded-[12px]">
        {images
          .filter((_, i) => i < 3)
          .map((image, i) => (
            <div key={i} className="relative aspect-[257/138]">
              <RenderImage
                onRemove={() => onRemove?.(i)}
                readOnly={readOnly}
                image={image instanceof File ? URL.createObjectURL(image) : image}
              />
            </div>
          ))}
        <div className="relative aspect-[257/138]">
          <RenderImage
            readOnly={true}
            image={images[3] && images[3] instanceof File ? URL.createObjectURL(images[3]) : images[3]}
          />
          <div className="z-1 absolute right-0 top-0 flex h-full w-full items-center justify-center bg-black/40">
            <span className="text-2xl">+{images.length - 4}</span>
          </div>
        </div>
      </div>
    )
  },
)
